import { REQUEST_ERROR, REQUEST_START, REQUEST_SUCCESS, SELECT_PLAYDAY } from 'state/actions/schedule'

const initialState = {
    selected_playday_id: 0,
    loading: true,
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case REQUEST_START: {
        return {
            ...state,
            loading: true,
        }
    }
    case SELECT_PLAYDAY: {
        return {
            ...state,
            selected_playday_id: action.payload.selected_playday_id,
        }
    }
    case REQUEST_SUCCESS: {
        const { response } = action.payload
        const [ playday_start, playday_end ] = getPlaydayStartEnd(response)
        return {
            ...state,
            loading: false,
            playdays: response,
            playday_start,
            playday_end,
        }
    }
    case REQUEST_ERROR: {
        return {
            ...state,
            error: true,
            loading: false,
        }
    }
    default:
        return state
    }
}


function getAllPrimetimes(playdays) {
    const allScheduleItems = [].concat(...playdays.map(pd => pd.schedule_items))
    const allSchedules = [].concat(...allScheduleItems.map(item => item.schedules))
    const allPeriods = [].concat(...allSchedules.map(schedule => schedule.periods).filter(_ => _.length))
    return allPeriods
}

function getPlaydayStartEnd(playdays) {
    const schedules = getAllPrimetimes(playdays)
    return getScheduleStartEnd(schedules)
}

export function getScheduleStartEnd(schedules) {
    let min = 23
    let max = 0

    schedules.forEach(([start, end]) => {
        if (isPeriodInside([min, max], [start, end])) {
            return
        } else if (isPeriodInside([start, end], [min, max])) {
            [min, max] = [start, end]
            return
        }

        min = Math.min(min, start)

        if (start > end && min < max) {
            max = Math.min(end, max)
        } else {
            max = Math.max(max, end)
        }
    })

    return [min, max]
}

/**
 * @returns {boolean} is second time period inside first
 * all arguments are expected to be [0-23]
 */
export function isPeriodInside([parentStart, parentEnd], [childStart, childEnd]) {
    if (parentStart <= parentEnd) {
        if (childStart < childEnd) {
            return childStart >= parentStart && childEnd <= parentEnd
        } else {
            return false
        }
    } else {
        if (childStart < childEnd) {
            return childStart >= parentStart || childEnd <= parentEnd
        } else {
            return childStart >= parentStart && childEnd <= parentEnd
        }
    }
}



// WEBPACK FOOTER //
// ./state/reducers/schedule.js